<template>
  <section class="container">
    <p>This page could not be found.</p>
  </section>

</template>

<script>

  export default {
    name: '404',
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
    },
    mounted () {
    },
    components: {
    }
  };
</script>

<style scoped>
  section {
    height: 100vh;
  }
  .container {
    max-width: 1000px;
    margin: 60px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/404.vue